interface ErrorMessageProps {
  title: string;
  message: string;
  suggestion?: string;
}

export const ErrorMessage = ({
  title,
  message,
  suggestion,
}: ErrorMessageProps) => {
  return (
    <>
      <h2 className="text-2xl font-bold text-foreground mb-2">{title}</h2>
      <p className="text-body-medium-regular text-muted-foreground mb-6">
        {message}
      </p>
      {suggestion && (
        <p className="text-body-small-regular text-muted-foreground/80 mb-6 italic">
          {suggestion}
        </p>
      )}
    </>
  );
};
